export class PathConstant {
    public static readonly EMPTY = '';
    public static readonly SEPERATOR = '/';
    public static readonly IMPORT = 'import';

    // Configuration Route
    public static readonly CUSTOMER = 'customer';
    public static readonly NEWS = 'news';
    public static readonly PROMOTION = 'promotion';
    public static readonly REDEMPTION = 'redemption';
    public static readonly VOUCHER = 'voucher';
    public static readonly CREW = 'crew';
    public static readonly PAYROLL = 'payroll';
    public static readonly ADVERTISEMENT = 'advertisement';
    public static readonly OUTLET = 'outlet';
    public static readonly IMAGES = 'images';
    public static readonly BANK = 'bank';
    public static readonly COMPANY = 'company';
    public static readonly VESSEL = 'vessel';
    public static readonly CHARGE_CODE = 'chargecode';
}
